/**
 * @file log
 * @author guoyong03
 */

/* globals swan */

/* globals getApp  getCurrentPages */

import { MiniProgram } from '@baidu/bend-sdk';
import { sendUbcShowLog } from '../../static/utils/ubcMethods.js';
import logs from '../../static/utils/ubcLog';
// import {request} from '../../static/utils/request.js';

const WEBB_URL = 'https://sp1.baidu.com/5b1ZeDe5KgQFm2e88IuM_a/mwb2.gif';
const WEBB_PID = '4_107';
const makeUrlParams = params => Object.keys(params).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key])).join('&');

/**
 * sendWebb
 * 性能日志
 * http://spy.baidu.com/#/doc/tool-webb.html
 *
 * @param {Object} opt 参数
 * @param {string} opt.type 类型
 * @param {Object} opt.info 数据 eg: {reqTime: 0}
 * @param {Object} opt.dim 属性 eg: {platform: 'browser', network: 'wifi'}
 * @param {string} opt.group 分组 fe or rd
 */
export function sendWebb({
  type = 'pf_comm',
  group = 'fe',
  info = {},
  dim = {}
}) {
  const sysInfo = getApp().globalData.sysInfo;
  const commonParams = {
    network: 'unknown',
    platform: sysInfo.platform,
    system: sysInfo.system,
    scene: getApp().globalData.scene
  };
  const getLogParams = () => {
    const newDim = Object.assign({}, dim, commonParams);
    return makeUrlParams({
      pid: WEBB_PID,
      lid: Date.now(),
      ts: Date.now(),
      dim: JSON.stringify(newDim),
      info: JSON.stringify(info),
      type,
      group
    });
  };
  const send = params => {
    const img = new Image();
    img.src = `${WEBB_URL}?${params}`;
  };
  getApp().$api.getNetworkType({
    success(res) {
      commonParams.network = res.networkType;
      send(getLogParams());
    },
    fail() {
      commonParams.network = 'unknown';
      send(getLogParams());
    }
  });
}

/**
 * sendInfo
 * 封装主动上报方法。 用于上报一些信息 例如 图片资源加载异常。 接口校验异常
 *
 * @param {Object} info 上报参数
 */
export function sendInfo(info) {
  let paths = getCurrentPages().map(item => item.uri);
  info = Object.assign(info, {
    paths
  });
  sendWebb({
    type: 'except',
    group: 'info',
    info
  });
}

/**
 * sendLog
 * 统一封装打点。小程序平台，和rd自运维统计
 *
 * @param {string} key 打点key
 * @param {Object} options 额外参数
 */
export function sendLog(key, options = {}) {
  // BI 日志中，把scene、sa、sid 作为默认值都放到 options 中作为ext 上报

  let ext = {
    sid: getApp().globalData.sid,
    sa: getApp().globalData.sa,
    scene: getApp().globalData.scene
    // city: getApp().globalData.location.cityName
  };

  ext.platform = 'h5';

  // 获取当前页面
  const page = getCurrentPages()[getCurrentPages().length - 1];
  if (page && page.privateProperties && page.privateProperties.accessUri) {
    ext.uri = page.privateProperties.accessUri;
  }
  let prePage = null;
  if (getCurrentPages().length > 1) {
    prePage = getCurrentPages()[getCurrentPages().length - 2];
  }
  if (prePage && prePage.privateProperties && prePage.privateProperties.accessUri) {
    ext.preUri = prePage.privateProperties.accessUri;
  }
  Object.assign(ext, options);
  // }
  let log = {};
  log = window.bendSDKLog.log;
  log.sendClickLog({
    /* eslint-disable */
    mod: key,
    ext: ext,
    // 如果存在options.id，s_id 更具有语义
    s_id: options.id || ''

    /* eslint-enable */
  });
}

/**
 * oldSendLog
 * 旧版本日志方法
 *
 * @param {string} mod 打点key
 * @param {Object} options 额外参数
 */
export let oldSendLog = (mod, options = {}) => {
  let log;
  let env = "h5";
  let ext = {
    platform: 'h5'
  };
  Object.assign(ext, options);
  log = window.bendSDKLog.log;
  log.sendClickLog({
    mod: env + '-' + mod,
    ext
  });
};
/**
 * inSightObserver
 * 判断元素是否出现在view之内，上报曝光日志
 * 依赖dom元素上的 data-key 区分是否已发送过日志。
 *
 * @param {string} target 打点key
 * @param {Object} logKey 打点key
 * @param {Object} ext 额外的打点key
 * @param {Object|Array} extDataKeys 需要从dataset里取的日志参数keys
 */
let intersectionObserver = {};
// keys 用来存储按钮是否已经打过点
let keys = {};
export function inSightObserver(target = 'defaultClass', logKey, ext, extDataKeys, isUbc = false, callBack = '') {
  if (!getApp().$api.createIntersectionObserver) {
    return false;
  }

  // 保持只有一个监听器
  // inSightObserverDisconnect();
  const IntersectionObserver = getApp().$api.createIntersectionObserver(this, {
    selectAll: true
  });
  IntersectionObserver.relativeToViewport({
    // 底部bar高度
    bottom: -60
  }).observe(target, res => {
    let key = res.dataset.key;
    let data = {
      insight: 1,
      id: res.dataset.id || ''
    };
    if (extDataKeys) {
      if (Array.isArray(extDataKeys)) {
        extDataKeys.forEach(v => {
          data[v] = res.dataset[v];
        });
      }
      if (Object.prototype.toString.call(extDataKeys) === '[object Object]') {
        const dataKeys = Object.keys(extDataKeys);
        dataKeys.forEach(k => {
          const name = extDataKeys[k];
          if (name) {
            data[name] = res.dataset[k];
          }
        });
      }
    }
    if (ext) {
      data = Object.assign({}, data, ext);
    }
    if (res.intersectionRect.height > 0 && key && !keys[key]) {
      if (!!callBack && (typeof callBack === 'object' || typeof callBack === 'function')) {
        try {
          callBack({
            url: res.dataset.url,
            loginNeeded: false
          });
        } catch (err) {
          console.log(err); // eslint-disable-line
        }
      } else {
        if (isUbc) {
          let {
            page,
            value,
            ext,
            extswan = {},
            serverid,
            area
          } = res.dataset;
          logs.send({
            serverId: serverid,
            page,
            area,
            action: 'show',
            ext: JSON.stringify(extswan),
            ...extswan
          });
          sendUbcShowLog({
            page,
            value,
            ext: {
              ...ext,
              ...extswan
            }
          });
        } else {
          sendLog(logKey, data);
        }
      }
      // 后续不在打点
      keys[key] = 1;
    }

    // 监控左右滑动
    if (res.intersectionRect.left > 0 && key && !keys[key] || res.intersectionRect.right > 0 && key && !keys[key]) {
      if (isUbc) {
        let {
          page,
          value,
          ext
        } = res.dataset;
        sendUbcShowLog({
          page,
          value,
          ext
        });
      } else {
        sendLog(logKey, data);
      }
      // 后续不在打点
      keys[key] = 1;
    }
  });
  intersectionObserver[target] && intersectionObserver[target].disconnect();
  intersectionObserver[target] = IntersectionObserver;
}

/**
 * inSightObserverDisconnect
 * 停止监听
 *
 */
export function inSightObserverDisconnect() {
  Object.keys(intersectionObserver).forEach(item => {
    intersectionObserver[item].disconnect();
  });
  // intersectionObserver && intersectionObserver.disconnect();
  intersectionObserver = {};
}

/**
 * isShowFixedInSight
 * 判断固定位按钮是否打曝光日志。
 *
 * @param {string} key 打点key
 * @return {boolean} 是否可打曝光日志
 *
 */
export function isShowFixedInSight(key) {
  if (key && !keys[key]) {
    keys[key] = 1;
    return true;
  }
  return false;
}